export const panelName = 'adminpanel';
export const appTitle = 'Admin Panel';

export const subDomain = window.location.hostname.split('.')[0];
export const sdSubDomains = ['sdfin', 'sdap', 'sdlocal', 'sdfinlocal'];
export const isSd = sdSubDomains.includes(subDomain);

const defaulLogo =
  'https://images1.shopup.online/assets/1606212780_group-13@3x.png';

const sdLogo = 'https://images1.shopup.online/uc/0000/1764587234_bongo.png';

export const logo = isSd ? sdLogo : undefined;
export const navLogo = isSd ? sdLogo : defaulLogo;

export const theme = isSd ? 'mokam' : 'oms';

export const initialPath = '/';
export const loginRedirectPath = '/login';
export const showTopbar = false;
